import React, { useState, useCallback, useRef, useEffect } from 'react';

let showToastGlobal = null;

export const toast = {
  success: (message) => showToastGlobal?.({ message, type: 'success' }),
  error: (message) => showToastGlobal?.({ message, type: 'error' }),
  info: (message) => showToastGlobal?.({ message, type: 'info' }),
};

const Toast = () => {
  const [toasts, setToasts] = useState([]);
  const idRef = useRef(0);

  const addToast = useCallback(({ message, type }) => {
    const id = ++idRef.current;
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 3500);
  }, []);

  useEffect(() => {
    showToastGlobal = addToast;
    return () => { showToastGlobal = null; };
  }, [addToast]);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map(t => (
        <div key={t.id} className={`toast-item toast-${t.type}`} role="status">
          <i className={`fas ${t.type === 'success' ? 'fa-check-circle' : t.type === 'error' ? 'fa-exclamation-circle' : 'fa-info-circle'}`} aria-hidden="true"></i>
          <span>{t.message}</span>
          <button
            className="toast-close"
            onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))}
            aria-label="Schließen"
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toast;
